<div class="onsight-form-input-select" *ngIf="myClass !== null" >
  <label>{{ myClass.langBase + label | translatePipe }}</label>
  <mat-form-field appearance="fill">
    <mat-select class="form-control" placeholder="{{ 'commons.forms.select' | translatePipe }}"
                [(ngModel)]="myClass.model[name]" name="{{ name }}" [required]="required">
      <input placeholder="{{ 'commons.filter' | translatePipe }}" class="select-search" (keyup)="onKey($event, 'hiringCompanyName')">
      <mat-option [value]="" [disabled]="true">{{ 'commons.forms.select' | translatePipe }}</mat-option>
      <mat-option [value]="hc.hiringCompanyID" *ngFor="let hc of list">{{ hc.companyName }}</mat-option>
    </mat-select>
  </mat-form-field>
</div>
